import { http, delayIt, useMockType as useMock } from './base';

export function getUserProjectList(params: object) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        status: 200,
        data: {
          success: true
        }
      };
    });
  } else if (process.env.NODE_ENV !== 'production' && useMock() === 'api.fe') {
    return http.get('http://api.fe.linkdoc.com/mock/515/sys/userProject/list', { params });
  }
  return http.get('/api/sys/userProject/list', { params });
}

export function setTop(projectId: number) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        status: 200,
        data: {
          success: true
        }
      };
    });
  } else if (process.env.NODE_ENV !== 'production' && useMock() === 'api.fe') {
    return http.post('http://api.fe.linkdoc.com/mock/515/sys/userProject/setTop', { projectId });
  }
  return http.post('/api/sys/userProject/setTop', { projectId });
}

export function cancelTop(projectId: number) {
  if (process.env.NODE_ENV !== 'production' && useMock() === 'local') {
    return delayIt(() => {
      return {
        status: 200,
        data: {
          success: true
        }
      };
    });
  } else if (process.env.NODE_ENV !== 'production' && useMock() === 'api.fe') {
    return http.post('http://api.fe.linkdoc.com/mock/515/sys/userProject/cancelTop', { projectId });
  }
  return http.post('/api/sys/userProject/cancelTop', { projectId });
}
